import { useParams } from "react-router-dom";
import { TrainerLectureConfirmationsTable } from "pages/TrainerLectureConfirmations/TrainerLectureConfirmationsTable";

export const CourseLectureConfirmationsPage = () => {
  const { courseId } = useParams();
  return <TrainerLectureConfirmationsTable courseId={Number(courseId)} />;
};
